import Loader from 'react-loaders';
import './index.scss';
import AnimatedLetters from '../AnimatedLetters';
import { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'

const Contact = () => {

    const [letterClass, setLetterClass] = useState('text-animate');

    // Reference for Email-JS :
    const refForm = useRef();

    setTimeout(() => {
        setLetterClass('text-animate-hover');
    }, 3000);

    function clearInputFields(){
        var myName = document.getElementById("_name");
        var myEmail = document.getElementById("_email");
        var myMessage = document.getElementById("_message");
        var mySubject = document.getElementById("_subject");
        myName.value = "";
        myEmail.value = "";
        myMessage.value = "";
        mySubject.value = "";
    }

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            'service_ue76u7g',
            'template_e0m09dv',
            refForm.current,
            'FBgZdKXkxoHy_wkY9'
        ).then(
            () => {
                alert('Email sent successfully! Thank you for contacting me.');
                clearInputFields();
            },
            (error) => {
                alert('Something went wrong, please try again.');
                console.log(error.text);
                clearInputFields();
            }
        )
    }
    const coordinates = [23.236436009007534, 87.88013395318329]

    document.title = "Portfolio | Contact";
    return (
        <>
        <div className="container contact-page">
            <div className="text-zone">
                <h1>
                    <AnimatedLetters letterClass={letterClass} myStr={"Contact"} idx={3} />{" "}
                    <AnimatedLetters letterClass={letterClass} myStr={"Me"} idx={2} />
                </h1>
                <p>
                    I am also interested in freelancing other than working in large tech tech companies. If you have any queries, please contact.
                </p>
                <div className="contact-form">
                    <form ref={refForm} onSubmit={sendEmail}>
                        <ul>
                            <li className='half'>
                                <input type="text" name='user_name' placeholder='Name' id="_name" required />
                            </li>
                            <li className='half'>
                                <input type="email" name='user_email' placeholder='Email' id="_email" required />
                            </li>
                            <li>
                                <input type="text" name='subject' placeholder='Subject' id="_subject" required />
                            </li>
                            <li>
                                <textarea name="message" id="_message" cols="30" rows="10"
                                placeholder='Message'
                                required>
                                </textarea>
                            </li>
                            <li>
                                <input type="submit"
                                className='flat-button' value='SEND MESSAGE' />
                            </li>
                        </ul>
                    </form>
                </div>
            </div>
            <div className="info-map">
                Soumyadev Saha,
                <br />
                West Bengal, India.
                <br />
                PURBASHA, Desh Bandhu Nagar, Kalna Gate,
                <br /> 
                Burdwan, DIST. Purba Barddhamaan, PIN - 713101.
                <br />
                <span>soumyadev1912@gmail.com</span>
            </div>
            <div className="map-wrap">
            <MapContainer center={coordinates} zoom={13} scrollWheelZoom={false}>
                <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={coordinates}>
                <Popup>
                    Soumyadev lives here. <br /> Come over for a cup of tea ;{")"}.
                </Popup>
                </Marker>
            </MapContainer>
            </div>
        </div>
        <Loader type="ball-spin-fade-loader" />
        </>
    );
}

export default Contact;